import { loadClassifyOptions, loadProductList, addCart } from '../../../../fetch/manage-center/purchase'
const types = {
  LOAD_CLASSIFY_DATA: 'LOAD_CLASSIFY_DATA',
  LOAD_PRODUCT_LIST: 'LOAD_PRODUCT_LIST',
  ADD_CART: 'ADD_CART'
}
const purchase = {
  state: {
    [types.LOAD_CLASSIFY_DATA]: null,
    [types.LOAD_PRODUCT_LIST]: [],
    [types.ADD_CART]: null
  },
  actions: {
    [types.LOAD_CLASSIFY_DATA]: async ({ commit }, pages) => {
      const res = await loadClassifyOptions(pages)
      return commit(types.LOAD_CLASSIFY_DATA, res)
    },
    [types.LOAD_PRODUCT_LIST]: async ({ commit }, pages) => {
      const res = await loadProductList(pages)
      return commit(types.LOAD_PRODUCT_LIST, res)
    },
    [types.ADD_CART]: async ({ commit }, pages) => {
      const res = await addCart(pages)
      return commit(types.ADD_CART, res)
    }
  },
  mutations: {
    [types.LOAD_CLASSIFY_DATA]: (state, res) => {
      state[types.LOAD_CLASSIFY_DATA] = res
    },
    [types.LOAD_PRODUCT_LIST]: (state, res) => {
      state[types.LOAD_PRODUCT_LIST] = res
    },
    [types.ADD_CART]: (state, res) => {
      state[types.ADD_CART] = res
    }
  },
  getters: {
    getClassifyOptions (state) {
      return state[types.LOAD_CLASSIFY_DATA]
    },
    getProductList (state) {
      return state[types.LOAD_PRODUCT_LIST]
    },
    getCartStatus (state) {
      return state[types.ADD_CART]
    }

  }
}
export default purchase
